<template>
  <v-select
    :items="items"
    :clearable="clearable"
    item-text="fullname"
    item-value="id"
    :label="$t('fields.propagandist')"
    :error-messages="errors"
    @input="changed"
    v-model="selected"
  >
    <template v-slot:append-item>
      <div v-intersect="endIntersect" />
    </template>
  </v-select>
</template>
<script>

import { propagandistsService } from '../../../utils/services/propagandists.service';

export default {
  name: 'PropagandistSelect',
  props: {
    errors: {
      type: [String, Array],
      default: '',
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      selected: this.value,
      items: [],
      paginations: {
        current_page: 1,
        last_page: 1,
      },
    };
  },
  methods: {
    changed(event) {
      this.$emit('input', event);
    },

    async endIntersect(entries, observer, isIntersecting) {
      if (isIntersecting) {
        if (this.paginations.current_page + 1 <= this.paginations.last_page) {
          const more = await this.fetch(this.paginations.current_page + 1);
          this.items = [...this.items, ...more];
        }
      }
    },

    async fetch(page) {
      return propagandistsService.index({
          page: page || 1,
          itemsPerPage: 15,
          filters: {
            sortBy: ['surname'],
            sortDesc: [false],
          },
        })
      .then(response => {
        const { current_page, last_page } = response.data.meta;
        this.paginations.current_page = current_page;
        this.paginations.last_page = last_page;
        return response.data.data;
      })
      .catch(error => {
          this.handleError(error, this.errors);
          return [];
      });
    },
  },
  async created() {
    this.items = await this.fetch(1);
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.selected = val;
      },
    },
  },
};
</script>
